import Vue from 'vue';

// Создаем шину событий
export const NotificationBus = new Vue();

export default {
  install(Vue, options = {}) {
    // Получаем функцию перевода из options
    const translator = options.translator || (key => key);

    // Создаем div для монтирования компонента
    const notificationDiv = document.createElement('div');
    notificationDiv.id = 'global-notification';
    document.body.appendChild(notificationDiv);

    // Создаем компонент
    const NotificationComponent = Vue.extend({
      vuetify: options.vuetify, // Важно! Передаем инстанс vuetify
      render(h) {
        return h('v-snackbar', {
          props: {
            value: this.show,
            color: this.color,
            timeout: this.timeout
          },
          on: {
            input: (val) => { this.show = val; }
          }
        }, [
          h('div', [
            h('div', { class: 'text-subtitle-1 font-weight-bold' }, this.title),
            this.text ? h('div', { class: 'text-body-2' }, this.text) : null
          ]),
          h('template', { slot: 'action' }, [
            h('v-btn', {
              props: { text: true },
              on: { click: () => { this.show = false; } }
            }, translator('custom.close'))
          ])
        ]);
      },
      data() {
        return {
          show: false,
          color: 'success',
          title: '',
          text: '',
          timeout: 3000
        };
      },
      methods: {
        notify(title, text = '', color = 'success', timeout = 3000) {
          this.title = title;
          this.text = text;
          this.color = color;
          this.timeout = timeout;
          this.show = true;
        }
      }
    });

    // Глобальный метод для удобного доступа
    Vue.prototype.$notify = (title, text = '', color = 'success', timeout = 3000) => {
      // Проверяем что color является строкой, иначе используем дефолтное значение
      const safeColor = (typeof color === 'string' && color) ? color : 'success';
      NotificationBus.$emit('show-notification', { title, text, color: safeColor, timeout });
    };
  }
};
